import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2, Megaphone, Send } from "lucide-react";
import { toast } from "sonner";

export default function AdminPackLaunch() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(null);
  const [result, setResult] = useState(null);
  const run = async (payload, kind) => {
    if (kind === "all" && !window.confirm("Email every opted-in subscriber (not yet announced) about their sector's policy packs?")) return;
    setBusy(kind);
    try {
      const { data } = await api.post("/admin/policy-content/announce", payload);
      setResult(data);
      toast.success(kind === "test" ? `Test sent to ${data.test_sent_to}` : `Launch email sent to ${data.sent} subscriber${data.sent === 1 ? "" : "s"}${data.already_sent ? ` · ${data.already_sent} already announced` : ""}`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Could not send"); } finally { setBusy(null); }
  };
  return (
    <div className="bg-card border border-border rounded-2xl p-5 flex flex-wrap items-center gap-3" data-testid="admin-pack-launch">
      <div className="flex-1 min-w-[240px]">
        <p className="font-display font-semibold flex items-center gap-2"><Megaphone className="w-4 h-4 text-accent" /> Pack launch email</p>
        <p className="text-xs text-muted-foreground mt-1">Tells each subscriber their sector's starter and complete packs are live, with prices and a sample extract. Each person is emailed once; opt-outs are respected.</p>
        {result && !result.test_sent_to && <p className="text-xs mt-1" data-testid="admin-pack-launch-result">Sent {result.sent} · already announced {result.already_sent}</p>}
      </div>
      <Button variant="outline" size="sm" disabled={!!busy} onClick={() => run({ test_email: user.email, sector: "cqc" }, "test")} data-testid="admin-pack-launch-test">{busy === "test" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send me a test"}</Button>
      <Button size="sm" disabled={!!busy} onClick={() => run({}, "all")} data-testid="admin-pack-launch-send">{busy === "all" ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-1.5" /> Send to all subscribers</>}</Button>
    </div>
  );
}
